
import {useState} from 'react'
import { useAuthContext } from './adminAuthHook'

export default function AgenciesStatsHook() {
    const apiUrl = process.env.REACT_APP_API_URL;
    const { admin } = useAuthContext()
    const[totalSearches,setTotalSearches]=useState(0)
    const[totalClicks,setTotalClicks]=useState(0)
    const[profileClicks,setProfileClicks]=useState(0)

    const getAgenciesStats=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/admin/agencies-stats/get-stats`,{
          headers:{
            'Authorization': `Bearer ${admin.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
            setTotalSearches(json.totalSearches)
            setTotalClicks(json.totalClicks)
            setProfileClicks(json.profileClicks)

        }
        
       } catch (error) {
       console.log('error',error)
       }
    }
  return {getAgenciesStats,totalSearches,totalClicks,profileClicks}
}
